import * as React from 'react';
import KPClaimListItem from './KPClaimListItem'
import { IClaimList, IClaimListItem, ILossType } from '../../../../interfaces/KPClaimList/KPClaimListInterfaces';
import { IDropdownData } from '../../../../interfaces/KPDropdown/KPDropdownInterfaces';
import './KPClaimList.css'

class KPClaimList extends React.PureComponent<IClaimList, any> {
    constructor(props) {
        super(props);

        this.state = {
            items: this.props.items ?? [],
            lossTypes: this.props.lossTypes ?? [],
            selectableLossTypes: [],
            submitted: false,
            btnNextDisabled: false
        };

        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleLossTypeChange = this.handleLossTypeChange.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleChangeCurrentPremises = this.handleChangeCurrentPremises.bind(this);
        this.handleAddNewItem = this.handleAddNewItem.bind(this);
        this.handleRemoveLastItem = this.handleRemoveLastItem.bind(this);
        this.validate = this.validate.bind(this);
    }

    setLossTypes(lossTypes: ILossType[]) {
        this.setState({ lossTypes });
        let selectableItems: IDropdownData[] = [];
        lossTypes.forEach(item => {
            selectableItems.push({
                id: item.id,
                description: item.description,
                productName: item.description,
                image: "",
            } as IDropdownData);
        });
        this.setState({ lossTypes, selectableItems });
    }

    setList(items: IClaimListItem[]) {
        this.setState({ items });
    }

    getList(): IClaimListItem[] {
        return [...this.state.items];
    }

    handleDateChange(id: string, date: Date) {
        let items = [...this.state.items];
        items.filter(x => x.id === id).forEach(item => { item.date = date; });
        this.setState({ items });
    }

    handleLossTypeChange(id: string, lossTypeId: string) {
        let items = [...this.state.items];
        let lossType = this.state.selectableItems.filter(x => x.id === lossTypeId)[0];
        items.filter(x => x.id === id).forEach(item => { item.lossType = lossType; });
        this.setState({ items });
    }

    handleValueChange(id: string, value: number) {
        let items = [...this.state.items];
        items.filter(x => x.id === id).forEach(item => { item.value = value; });
        this.setState({ items });
    }

    handleChangeCurrentPremises(id: string) {
        let items = [...this.state.items];
        items.filter(x => x.id === id).forEach(item => { item.currentPremises = !item.currentPremises; });
        this.setState({ items });
    }

    handleAddNewItem() {
        let items = [...this.state.items];
        let index = items.length + 1;
        items.push({
            id: index.toString(),
            index: index,
            date: null,
            lossType: null,
            lossTypes: this.state.selectableItems,
            value: null,
            currencySymbol: this.props.currencySymbol,
            canRemove: false,
            submitted: false,
            isExisting: false,
            claimType: this.props.claimType,
            currentPremises: false,
        } as IClaimListItem);
        this.setState({ items });
    }

    handleRemoveLastItem() {
        let items = [...this.state.items];
        items.pop();
        this.setState({ items });
    }

    validate(submitted: boolean = false): boolean {
        let valid = true;
        let items: IClaimListItem[] = [...this.state.items];
        items.forEach(item => {
            valid = valid && (item.date !== null && item.date !== undefined);
            valid = valid && (item.lossType !== null && item.lossType !== undefined);
            valid = valid && (item.value !== null && item.value !== undefined);
            item.submitted = submitted;
        });
        this.setState({ items, submitted });
        return valid;
    }

    public render() {
        let items: any = <></>;
        if (this.state.items && this.state.items.length > 0) {
            items = this.state.items.map((item, index) => {
                return <KPClaimListItem
                    key={index}
                    id={item.id}
                    index={index}
                    date={item.date}
                    lossType={item.lossType}
                    lossTypes={this.state.selectableItems}
                    value={item.value}
                    currencySymbol={this.props.currencySymbol}
                    handleDateChange={this.handleDateChange}
                    handleLossTypeChange={this.handleLossTypeChange}
                    handleValueChange={this.handleValueChange}
                    handleChangeCurrentPremises={this.handleChangeCurrentPremises }
                    handleRemove={this.handleRemoveLastItem}
                    canRemove={(index === this.state.items.length - 1) && (index > Number(this.props.initialCount) - 1)}
                    submitted={this.state.submitted}
                    isExisting={item.isExisting}
                    claimType={item.claimType}
                    currentPremises={item.currentPremises}
                />
            });
        }

        return (
            <div className="ssp-claim-list">
                <div><h4>Incident details</h4></div>

                {items}

                <div className="row">
                    <div className="col-12">
                        <div id="btnAddIncident" className="btn-add-incident" onClick={this.handleAddNewItem}>
                            <img src="./Images/icon-add-green-circle.svg" className="img-fluid btn-edit mr-2" /> Add another incident
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default KPClaimList